interface ErrorProps {
	error: string;
}

export const ErrorDisplay: React.FC<ErrorProps> = ({ error }) => {
	return (
		<>
			{error && (
				<span className="font-Poppins text-sm text-center text-red-500 rounded-md font-semibold inline-flex items-center">
					{error}
				</span>
			)}
		</>
	);
};
